<template>
    <table-view :controller="controller" :selection="selection" />
</template>

<script>
import TableView, {
    TableViewController,
} from '@topomatic/tap/src/components/TableView.vue';
import TableSimpleValue from '@topomatic/tap/src/components/TableSimpleValue.vue';
import TableUserValue from '@topomatic/tap/src/components/TableUserValue.vue';
import Utils from '@topomatic/tap/src/utils';

class RevisionsController extends TableViewController {
    constructor(owner, file) {
        super();
        this.owner = owner;
        this.file = file;
    }

    headers() {
        return [
            this.owner.$tr('Версия'),
            this.owner.$tr('Создал'),
            this.owner.$tr('Создан'),
            this.owner.$tr('Размер файла'),
        ];
    }

    length() {
        const { revisions } = this.file;
        return revisions != undefined ? revisions.length : 0;
    }

    id(row) {
        const { revisions } = this.file;
        return revisions[row].id;
    }

    component(row, column) {
        switch (column) {
        case 1:
            return TableUserValue;
        default:
            return TableSimpleValue;
        }
    }

    value(row, column) {
        const { file } = this;
        const { revisions } = file;
        const revision = revisions[row];
        switch (column) {
        case 0:
            return `${revision.n}.0`;
        case 1:
            return {
                value: this.owner.$api.get_user(revision.creator),
            };
        case 2:
            return Utils.dateTimeToString(revision.created);
        case 3:
            return {
                value: Utils.sizeToString(revision.length),
                action: {
                    title: this.owner.$tr('Скачать'),
                    icon: 'download',
                    revision,
                    onclick: this.owner.download,
                },
            };
        default:
            return '0';
        }
    }
}

export default {
    name: 'VersionsView',
    components: {
        TableView,
    },
    props: {
        payload: Object,
    },
    data() {
        return {
            controller: new RevisionsController(this, this.payload.file),
            selection: {
                selected: {},
                active: null,
            },
        };
    },
    computed: {
        $api() {
            return this.payload.api;
        },
    },
    methods: {
        download(action) {
            const { file } = this.payload;
            this.payload.download(file, action.revision);
        },
    },
};
</script>

<style scoped>

</style>
